<template>
  <div class="box">

    <admin-box-item :title="title"
                    :subtitle="desc"
                    :titleFlex="true"
                    :useTab="false">
      <div class="columns is-mobile is-multiline">
        <div class="column is-narrow"
             style="flex:auto"
            v-for="(item, idx) in itemItems" :key="'item-'+idx"
            v-if="item.type!=='search'">
          <admin-form-item :label="item.title" :tip="item.tip">
            <!--<label class="label">{{ item.title }}</label>-->

            <!-- 날짜(날짜+시간) 범위 -->
            <div v-if="item.type==='period' && item.start!==undefined"
                 class="columns is-multiline"
                 style="align-items: center; margin-left:0; margin-top:0; margin-right:0">

              <div style="align-items: center; margin-right:12px">
                <admin-date-picker
                  style="display: inline-block"
                  :data.sync="item.start.value"
                  :type="item.date_type"
                  @setDate="res => selDate(item, item.start.key, res)"></admin-date-picker>
                <div class="lp-dating" style="margin-right:0">&#126;</div>
              </div>
              <div style="align-items: center;">
                <admin-date-picker
                  style="display: inline-block"
                  :data.sync="item.end.value"
                  :type="item.date_type"
                  @setDate="res => selDate(item, item.end.key, res)"></admin-date-picker>
              </div>
            </div>

            <div v-if="item.type==='period1' && item.start!==undefined"
                 class="columns is-multiline"
                 style="align-items: center; margin-left:0; margin-top:0; margin-right:0">
              <span class="select" style="margin-bottom: 0.5rem;margin-right: 6px;height: 31px;"
                    v-if="Array.isArray(item.key)">
                <select @change="e=>selectPeriodType(e,item)">
                  <option v-for="(it, key_idx) in item.key" :key="'opt-key-'+key_idx" :value="it.value">{{ it.label }}</option>
                </select>
              </span>
              <div class="flex-align" style="margin-right:12px;">
                <div v-for="(day, day_idx) in dayItems"
                     class="unselect day-item"
                     :class="{'selected': day.selected}"
                     @click="selectDay(day, item)"
                     :key="`day-${day_idx}`">{{ day.label }}</div>
              </div>
              <div style="align-items: center; margin-right:12px">
                <admin-date-picker
                  style="display: inline-block"
                  :data.sync="item.start.value"
                  @setDate="res => selDate1(item, item.start.key, res)"></admin-date-picker>
                <div class="lp-dating" style="margin-right:0">&#126;</div>
              </div>
              <div style="align-items: center;">
                <admin-date-picker
                  style="display: inline-block"
                  :data.sync="item.end.value"
                  @setDate="res => selDate1(item, item.end.key, res)"></admin-date-picker>
              </div>
            </div>


            <!-- 시간 범위 -->
            <div v-if="item.type==='time' && item.start_time!==undefined"
                 class="columns is-multiline"
                 style="align-items: center; margin-left:0; margin-top:0; margin-right:0">
              <time-range-picker :start_time="item.start_time"
                                 :end_time="item.end_time"
                                 :unit="5"
                                 @update:start_time="res => selTime('start_time', res)"
                                 @update:end_time="res => selTime('end_time', res)"/>
            </div>

            <!-- 지역 -->
            <div v-if="item.type==='region'"
                 style="align-items: center; margin-left:0; margin-top:0"
                 class="columns is-multiline">
              <div style="margin-right: 8px;margin-bottom:8px">
                <span class="select">
                  <select v-model="item.value.sido" @change="selSido(item, item.value)">
                    <option value="" disabled selected>시/도</option>
                    <option v-for="sido in item.options.sido" :key="'sido-'+sido.value"
                            :value="sido.value">{{ sido.label }}</option>
                  </select>
                </span>
              </div>

              <div style="margin-right: 8px;margin-bottom:8px">
                <span class="select">
                    <select v-model="item.value.sigungu" @change="selSigungu(item, item.value)">
                      <option value="" disabled selected>시/군/구</option>
                      <option v-for="sigungu in item.options.sigungu"  :key="'sigungu-'+sigungu.value"
                              :value="sigungu.value">{{ sigungu.label }}</option>
                    </select>
                  </span>
              </div>

              <div style="margin-right: 8px;margin-bottom:8px">
                  <span class="select">
                    <select v-model="item.value.dong" @change="selDong(item, item.value)">
                      <option value="" disabled selected>읍/면/동</option>
                      <option v-for="dong in item.options.dong" :key="'dong-'+dong.value"
                              :value="dong.value">{{ dong.label }}</option>
                    </select>
                  </span>
              </div>
            </div>

            <!-- 카테고리 -->
            <div v-if="item.type === 'category'"
                 style="align-items: center; margin-left:0; margin-top:0"
                 class="columns is-multiline">
              <div v-for="catIdx in [1,2,3]" :key="'cat-'+catIdx" style="margin-right: 8px;margin-bottom:8px">
                  <span class="select">
                    <select v-model="item.value[`category${catIdx}`]"
                            @change="selCategory(item, catIdx)">
                      <option value="" disabled selected>{{ catIdx }}차 카테고리</option>
                      <option v-for="(cat, idx) in item.options[`category${catIdx}`]" :key="'catItem-'+idx"
                              :value="cat.value">{{ cat.label }}</option>
                    </select>
                  </span>
              </div>
            </div>


            <!-- 슬롯 -->
            <div class="columns is-multiline"
                 style="align-items: center; margin:0;">
              <slot :name="item.type"></slot>
            </div>

            <!-- 가격 -->
            <div v-if="item.type==='price'" class="control is-grouped flex">
              <div class="control is-expanded">
                <input class="input lp-price-input"
                       type="number"
                       v-model="selectedMinPrice"
                       v-for="(it,idx) in item.list"
                       :key="'min_price-'+idx"
                       v-if="it.key==='min_price'">
              </div>
              <div class="lp-dating">&#126;</div>
              <div>
                <input class="input lp-price-input"
                       type="number"
                       v-model="selectedMaxPrice"
                       v-for="(it,idx) in item.list"
                       :key="'max_price-'+idx"
                       v-if="it.key==='max_price'">
              </div>
            </div>

            <!-- 드롭다운 리스트 -->
            <div v-if="item.type==='dropdown'">
              <div class="control">
                  <span class="select">
                    <select v-model="item.value" @change="changeDropdown(item)">
                      <option value="" disabled selected>{{ item.title }}</option>
                      <option v-for="(option,idx) in item.options"
                              :key="'drop-'+idx"
                              :value="option.value">{{ option.label }}</option>
                    </select>
                  </span>
              </div>
            </div>

            <!-- 라디오 버튼 -->
            <div v-if="item.type==='radiobutton'">
              <div class="control">
                <lp-radio :data="item.options"
                          value_name="value"
                          label_name="label"
                          :val.sync="item.value"
                          @onSelect="res => selRadio(item.key, res)"></lp-radio>
              </div>
            </div>

            <!-- 체크박스 -->
            <div v-if="item.type==='checkbox'">
              <div class="control">
                <lp-check-group :list="item.options"
                                :data="item.value"
                                @check="selCheckBox(item.key, item.value)"
                                value_name="value"
                                label_name="label"></lp-check-group>
              </div>
            </div>
          </admin-form-item>
        </div>
      </div>

      <!-- 통합 검색 -->
      <div class="columns" v-if="searchItem">
        <div class="column is-6">
          <label class="label">{{ searchItem.title }}</label>
          <div class="columns">
            <div class="column" style="padding-right:0 !important">
              <span class="select" :style="searchStyle">
                <select class="lp-filter-select" v-model="searchItem.search_type"
                        :style="searchStyle"
                        @change="selSearchType(searchItem)">
                  <option value="" disabled selected>통합검색</option>
                  <option v-for="(option,idx) in searchItem.options"
                          :key="'option-'+idx"
                          :value="option.value">{{ option.label }}</option>
                </select>
              </span>
            </div>
            <div class="column is-11 flex" style="padding-right:0 !important">
              <input class="input lp-filter-input"
                     type="text"
                     :value="searchItem.search_keyword"
                     @input="e => searchItem.search_keyword = e.target.value"
                     @keyup.enter="clickSearch(searchItem)">
              <button class="button is-primary" @click="clickSearch(searchItem)">검색</button>
            </div>
          </div>
        </div>
      </div>
    </admin-box-item>
  </div>
</template>

<script>
  import moment from 'moment';
  import LpSortDropDown from "../common/LpSortDropDown";
  import LpRadio from '../common/LpRadio'
  import AdminDatePicker from "./AdminDatePicker";
  import AdminFormItem from "./AdminFormItem";
  import LpCheckGroup from "../common/LpCheckGroup";
  import TimeRangePicker from "../common/timeRangePicker";

  export default {
    // 필드명, 필터아이템리스트, 실제 filter값
    components: {
      TimeRangePicker,
      LpCheckGroup,
      AdminFormItem,
      AdminDatePicker,
      LpSortDropDown,
      LpRadio
    },
    /*
    *  items: [ { title:'가입일, type:'period' }, { title:'통합검색', type:'search', options:[{label:"전체", value:"all"},{}..] ]
    *  itemFiltered: { cur_page:"1", page_length:"10", page_num:1, total_page:1 }
    *  itemFiltered는 초기값이 위처럼 세팅되어있고 추가로 Adminfilter나 AdminTable에서 필터관련 액션을 취할 경우 itemFiltered에 값이 추가된다.
    * */
    props:['items', 'itemFiltered', 'title', 'desc'],

    data(){
      return {
        searchItem: undefined,
        itemItems: [],
        start: '',
        end: '',
        nowTime: '',
        nowOpened: '',
        filtered: undefined,

        selectedSearchType:'',
        selectedSearchKeyword:'',

        selectedMinPrice:'',
        selectedMaxPrice:'',

        // 카테고리 배열 미리 저장
        catArr1:[],
        catArr2:[],
        catArr3:[],
        // 선택할때마다 카테고리에 저장
        cat2:[],
        cat3:[],
        dayItems:[{
          label:'오늘',
          selected: true
        },{
          label:'어제',
          selected: false
        },{
          label:'1주일',
          selected: false
        },{
          label:'1개월',
          selected: false
        },{
          label:'3개월',
          selected: false
        }]
      }
    },
    computed: {
      searchStyle(){
        if(this.$store.getters.device==='mobile') {
          return 'width:100% !important'
        }
      }
    },
    created(){
      this.init();
    },
    watch:{
      itemFiltered: {
        handler(n) {
          if(n) {
            this.filtered = this.itemFiltered;
          }
        },
        deep: true
      },
      items: {
        handler(n) {
          if(n) {
            this.init();
          }
        },
        deep: true
      },
      selectedMinPrice(n){
        this.filtered.min_price=n;
        this.$emit('getData');
      },
      selectedMaxPrice(n){
        this.filtered.max_price=n;
        this.$emit('getData');
      }
    },
    methods: {
      init() {
        this.filtered = this.itemFiltered;
        this.itemItems = [];
        this.itemItems = this.cloneItem(this.items);
        this.searchItem = find(this.itemItems, 'type', 'search');
        this.nowTime = moment().format('YYYY-MM-DD');
        this.$root.$on('openListType', (type) => {
          this.nowOpened = type;
        });
        this.setItems();
        this.getCategory();
        this.dayItems.forEach(item=>{
          item.selected = false;
        })
        this.dayItems[0].selected = true;
      },
      selectDay (day, item) {
        this.dayItems.forEach(day => {
          day.selected = false;
        })
        day.selected=true;
        let nowTime = moment();
        item.end.value = nowTime.format('YYYY-MM-DD');
        // item.end.value =
        // this.filtered[item.end.key

        switch(day.label) {
          case '오늘':
            item.start.value = item.end.value;
            break;
          case '어제':
            item.start.value = nowTime.subtract(1, 'days').format('YYYY-MM-DD');
            break;
          case '1주일':
            item.start.value = nowTime.subtract(7, 'days').format('YYYY-MM-DD');
            break;
          case '1개월':
            item.start.value = nowTime.subtract(1, 'months').format('YYYY-MM-DD');
            break;
          case '3개월':
            item.start.value = nowTime.subtract(3, 'months').format('YYYY-MM-DD');
            break;
        }
        this.filtered.page_num=1;
        this.filtered[item.start.key] = item.start.value;
        this.filtered[item.end.key] = item.end.value;
        this.$emit('update:itemFiltered', this.filtered);
        this.$emit('getData');
      },
      // 날짜 기간 초기값 설정
      getPeriodStart(){
        // 오늘 전화 연결 내역에서 현재 날짜로 저장
        //let name = this.$route.fullPath.split('/')[this.$route.fullPath.split('/').length-1]
        let name = this.$route.fullPath
        if(
          [
            '/office/admin/cs/call/new',
            '/office/admin/cs/call/order/new',
            '/office/admin/outlink/new',
            '/office/admin/request/new',
            '/office/admin/counsel/request/new',
            '/office/admin/meet/request/new',
            '/office/admin/group/calendar'
          ].indexOf(name)>-1) {
          return this.nowTime;
        }
        else if(name.indexOf('launchpack/utilize')>-1) {
          return moment().format('YYYY-') + '01-01';
        }
        // 2017-01-01 설정 주석처리
        //else return moment('2017-01-01').format('YYYY-MM-DD');
      },
      setItems() {
        for(let i=0; i<this.itemItems.length; i++) {
          let item = this.itemItems[i];
          // 기간
          if(item.type === 'period' || item.type === 'period1') {
            let start = this.nowTime;
            //let end = this.nowTime;
              if(item.type==='period') {
                start = this.getPeriodStart();
                if(item.date_type==='datetime') {
                  start = moment(moment().format('YYYY-MM-DD')+' 00:00').format('YYYY-MM-DD HH:mm')
                  //end = moment(moment().format('YYYY-MM-DD')+' 23:50').format('YYYY-MM-DD HH:mm')
                }
              }
            let start_key = 'start';
            let end_key = 'end';
            if(Array.isArray(item.key)) {
              if(item.key.length>0) {
                if(!item.key[0].value) {
                  start_key = `start`;
                  end_key = `end`;
                }
                else {
                  start_key = `${item.key[0].value}_start`;
                  end_key = `${item.key[0].value}_end`;
                }
              }
              if(item.start !== 'no_initn') {
                item.start = { key: start_key, value: start };
              } else {
                item.start = {key: start_key, value: undefined};
              }
              item.end = { key: end_key, value: undefined };
            } else {
              if(item.key) {
                start_key = `${item.key}_start`;
                end_key = `${item.key}_end`;
              }

              if(item.start !== 'no_init') {
                item.start = { key: start_key, value: start };
              } else {
                item.start = {key: start_key, value: undefined};
              }
              if(!item.end) {
                item.end = { key: end_key, value: undefined };
              }
            }
          }

          // 시간
          else if(item.type === 'time') {
            item.start_time = '00:00';
            item.end_time = '23:55';
          }

          // 지역
          else if(item.type === 'region') {
            item.value = {
              // sido: {value: '', label: ''},
              // sigungu: {value: '', label: ''},
              // dong: {value: '', label: ''}
              sido: '',
              sigungu: '',
              dong: ''
            };

            this.$axios.get('public/address/basic/sido').then(res => {
              let region = find(this.itemItems, 'type', 'region');
              region.options.sido = res.data;
            });
          }
          // 카테고리
          else if(item.type === 'category') {
            item.value = {
              category1: '',
              category2: '',
              category3: '',
            };
          }
          // 드롭다운
          else if(item.type === 'dropdown') {
            item.value = '';

            // 성별
            if(item.key === 'gender') {
              item.options = [
                {label: '전체', value: ''},
                {label: '여', value: 'female'},
                {label: '남', value: 'male'}
              ]
            }

            // 가입 종류
            if(item.key === 'joined_type') {
              item.options = [
                {label: '전체', value: ''},
                {label: '이메일', value: 'email'},
                {label: '네이버', value: 'naver'},
                {label: '카카오', value: 'kakao'},
                {label: '페이스북', value: 'facebook'}
              ];
            }

            if (item.key === 'channel') {
              item.options = [
                {label: '전체', value: ''},
                {label: '런치팩', value: '런치팩'},
                {label: '플랫폼파이', value: '플랫폼파이'},
              ]
            }

            // 견적요청 폼
            if ( item.key === 'estimate_form' ) {
              this.$axios.get('public/estimate/form/simple')
              .then(res=>{
                if(res.status===200){
                  item.options = res.data;
                }
              })
            }

            // 상담신청 폼
            if ( item.key === 'counsel_form' ) {
              this.$axios.get('public/counsel/form/simple')
                .then(res=>{
                  item.options = res.data;
                })
            }

            // 상담신청 폼
            if ( item.key === 'meet_form' ) {
              this.$axios.get('public/meet/form/simple')
                .then(res=>{
                  item.options = res.data;
                })
            }

            if ( item.key === 'approve_grade' ) {
              this.$axios.get('public/member/grade')
                .then(res=>{
                  item.options = res.data;
                })
            }

            if ( item.key === 'package' ) {
              let options = [];
              this.$axios.get('public/service/packages').then(res => {
                let packages = res.data;
                for (let i = 0; i < packages.length; i++) {
                  options.push({label: this.convertPackName(packages[i]), value: packages[i].name});
                }

                item.options = options;
              })
            }

            if ( item.key === 'grade' ) {
              this.$axios.get('public/member/grade') .then(res=>{
                item.options = res.data;
              })
            }

          }

          // 통합검색
          else if(item.type === 'search') {
            item.search_type = '';
            item.search_keyword = '';
          }
        }
      },

      selSido(item, value) {
        // 시군구 불러오기
        this.$axios.get('public/address/basic/sido/' + value.sido + '/sigungu').then(res => {
          item.options.sigungu = res.data;
          item.options.dong = [];
        });

        // 필터링한 데이터 불러오기
        this.filtered.sido = value.sido;
        this.filtered.sigungu = '';
        this.filtered.dong = '';
        this.filtered.page_num = 1;
        this.$emit('update:itemFiltered', this.filtered);
        this.$emit('getData');
      },
      selSigungu(item, value) {
        // 동읍면 불러오기
        this.$axios.get('public/address/basic/sido/' + value.sido + '/sigungu/' + value.sigungu + '/dong').then(res => {
          item.options.dong = res.data;
        });

        // 필터링한 데이터 불러오기
        this.filtered.sigungu = value.sigungu;
        this.filtered.dong = '';
        this.filtered.page_num = 1;
        this.$emit('update:itemFiltered', this.filtered);
        this.$emit('getData');
      },
      selDong(item, value) {
        // 필터링한 데이터 불러오기
        this.filtered.dong = value.dong;
        this.filtered.page_num = 1;
        this.$emit('update:itemFiltered', this.filtered);
        this.$emit('getData');
      },
      // 통합검색 타입 선택
      selSearchType(item) {
        this.filtered.page_num = 1;
        this.filtered.search_type = item.search_type;
        delete this.filtered.param_value;
        delete this.filtered.param_name;

        this.$emit('update:itemFiltered', this.filtered);
        // this.$emit('getData');
      },
      // 검색
      clickSearch(item) {
        this.filtered.page_num=1;
        this.filtered.search_keyword = item.search_keyword;
        if(item.search_type && item.search_type.indexOf('param__')>-1) {
          this.filtered.param_value = item.search_keyword;
          this.filtered.param_name = item.search_type.replace('param__','');
          delete this.filtered.search_keyword;
          delete this.filtered.search_type;
        }

        this.$emit('update:itemFiltered', this.filtered);
        this.$emit('getData');
      },
      // 드롭다운 변경
      changeDropdown(item) {
        this.filtered.page_num=1;
        this.filtered[item.key] = item.value;
        this.$emit('update:itemFiltered', this.filtered);
        this.$emit('getData');
      },
      selDate1(item, type, value) {
        this.filtered.page_num=1;
        this.filtered[type] = value;
        this.dayItems.forEach(it => {
          it.selected = false;
        })
        if(type.indexOf('start')>-1) {
          item.start.value = value;
        }
        else if(type.indexOf('end')>-1) {
          item.end.value = value;
        }
        this.$emit('update:itemFiltered', this.filtered);
        this.$emit('getData');
      },
      selDate(item, type, value) {
        if(!this.filtered) return;
        this.filtered.page_num=1;
        this.filtered[type] = value;
        // this.dayItems.forEach(it => {
        //   it.selected = false;
        // })
        if(type.indexOf('start')>-1) {
          item.start.value = value;
        }
        else if(type.indexOf('end')>-1) {
          item.end.value = value;
        }
        this.$emit('update:itemFiltered', this.filtered);
        this.$emit('getData');
      },
      selTime(type, value) {
        this.filtered.page_num=1;
        this.filtered[type] = value;
        this.$emit('update:itemFiltered', this.filtered);
        this.$emit('getData');
      },
      selCategory(item, idx) {
        this.filtered.page_num=1;
        let catName = `category${idx}`;
        this.filtered[`cat${idx}`] = item.value[catName];
        if(idx === 1) {
          this.get_cat2(item);
          this.filtered.cat2 = '';
          this.filtered.cat3 = '';
        }
        else if(idx === 2) {
          this.get_cat3(item);
          this.filtered.cat3 = '';
        }

        this.$emit('update:itemFiltered', this.filtered);
        this.$emit('getData');
      },
      get_cat2(item) {
        item.options.category2 = [];
        for (let i = 0; i < this.catArr2.length; i++) {
          if (this.catArr2[i].parent === this.filtered.cat1) {
            item.options.category2.push(this.catArr2[i]);
          }
        }
      },
      get_cat3(item) {
        item.options.category3 = [];
        for (let i = 0; i < this.catArr3.length; i++) {
          if (this.catArr3[i].parent === this.filtered.cat2) {
            item.options.category3.push(this.catArr3[i]);
          }
        }
      },
      getCategory(){ // 카테고리 가져오기
        if(this.$store.getters.mode==='superpartner') return;
        let url = 'category';
        if(this.$route.path==='/office/admin/board') url ='board/category';
        else if(this.$route.path.indexOf('space/') > -1) url ='space/category';

        this.$axios.get(this.getUrl(url))
          .then(res => {

            this.catArr1 = [];
            this.catArr2 = [];
            this.catArr3 = [];

            for (let i = 0; i < res.data.length; i++) {
              let cat = res.data[i];
              // 1차 카테고리 추가
              this.catArr1.push({value: cat.id, label: cat.name});

              for (let j = 0; j < cat.child.length; j++) {
                let cat2 = cat.child[j];
                // 2차 카테고리 추가
                this.catArr2.push({parent: cat.id, value: cat2.id, label: cat2.name});

                for (let k = 0; k < cat2.child.length; k++) {
                  let cat3 = cat2.child[k];
                  // 3차 카테고리 추가
                  this.catArr3.push({parent: cat2.id, value: cat3.id, label: cat3.name});
                }
              }
            }

            let cats = find(this.itemItems, 'type', 'category');
            if(cats!==undefined)
              cats.options.category1 = this.catArr1;
          });
      },
      selRadio(key, value) {
        this.filtered.page_num=1;
        this.filtered[key] = value;
        this.$emit('getData');
      },

      selCheckBox(key, value) {
        this.filtered.page_num = 1;
        let status_list = '';
        for(let i=0; i<value.length; i++) {
          // 전체 선택일 경우 예외처리
          if(value[i]==='all') {
            status_list = '';
            break;
          }
          if(i===value.length-1) {
            status_list += value[i];
          }
          else {
            status_list += value[i] + ','
          }
        }
        this.filtered[key] = status_list;
        this.$emit('update:itemFiltered', this.filtered);
        this.$emit('getData');
        // console.log('체크박스 선택', key, value);
      },
      selectPeriodType(e,item) {
        delete this.filtered.start;
        delete this.filtered.end;
        [{label: '주문일자', value: ''},
          {label: '주문일자', value: ''},
          {label: '입금대기일자', value: 'dt_100'},
          {label: '결제일자', value: 'dt_101'},
          {label: '상품준비중일자', value: 'dt_200'},
          {label: '배송대기일자', value: 'dt_300'},
          {label: '배송중일자', value: 'dt_301'},
          {label: '배송완료일자', value: 'dt_302'},
          {label: '구매확정일자', value: 'dt_400'},
          {label: '취소요청일자', value: 'dt_500'},
          {label: '취소완료(입금전 주문취소)', value: 'dt_503'},
          {label: '취소완료(환불 완료)', value: 'dt_504'}].forEach(it => {
          delete this.filtered[`${it.value}_start`];
          delete this.filtered[`${it.value}_end`];
        })
        let value = e.target.value;
        if(value) {
          item.start.key = `${value}_start`;
          item.end.key = `${value}_end`;
        } else {
          item.start.key = 'start';
          item.end.key = 'end';
        }
      }

     /* // value가 list안에 있는 경우
      setFilterList(key){
        for(let i=0; i<this.items.length; i++) {
          if(this.items[i]['list']){
            for(let j=0; j<this.items[i].list.length; j++){
              if(this.items[i].list[j].key===key){
                this.filtered[key]=this.items[i].list[j].value;
              }
            }
          }
        }
        // emit
        this.$emit('update:itemFiltered', this.filtered);
        this.$emit('getData');
      }*/
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'

  .lp-price-input
  .lp-filter-input {
    border: 1px solid #dbdbdb;
    color: #363636;
    padding: 8px;
    font-size: 0.9rem;
    border-radius: 3px;
  }

  .lp-filter-input {
    width: 250px
    margin-right: 8px
  }

  .lp-price-input {
    width: 120px
  }

  .lp-dating {
    display:inline-block;
    margin: 0 8px;
    font-size: 18px;
    color:#064160
  }
  .day-item {
    font-size: 14px;
    text-align: center;
    width: 51px;
    height: 31px;
    line-height: 31px;
    color: #363636;
    border: 1px solid #dbdbdb;
    border-radius: 4px;
    margin-right: 2px;
    margin-bottom: 0.5rem
  }
  .day-item.selected {
    color: $primary;
    border: 1px solid $primary
  }
</style>
